module.exports = __webpack_public_path__ + "images/auth-background.e0c2a4f8201e160f0e7fa5f4db88024d.jpg";